import { IntegrationConfig } from 'modules/Integrations/domain'
import logo from './attioLogo.svg'
import { AttioIntegrationDetail } from './AttioIntegrationDetail/AttioIntegrationDetail'
import { AttioIntegrationManagement } from './AttioIntegrationManagement/AttioIntegrationManagement'

export const attioIntegrationConfig: IntegrationConfig = {
  logoUrl: logo,
  smallLogoUrl: logo,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors',
  title: 'Attio',
  features: {
    canDeleteLinks: false,
    canUninstall: false,
    isDocumentationOnly: false
  },
  description: 'Launch quotes from Attio and sync records with Sequence.',
  components: {
    detail: AttioIntegrationDetail,
    management: AttioIntegrationManagement
  }
}
